
var transferLess = {};
import genaration from '../../utils/classname';
export var transferClass = genaration(transferLess, 'transfer');